import React from 'react';
import Widget from '../domain/Widget';
import { t, props } from 'tcomb-react';

@props({
  widget: t.maybe(Widget)
})
export default class WidgetHeader extends React.Component {

  render() {
    const { widget } = this.props;
    if (!widget) {
      return null;
    }

    return (
      <div className="WidgetHeader">
         <img src={widget.header_image}/>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/WidgetHeader.js
 **/